import {Form} from 'antd'
import meta from './metaVm.mjs'
import Select from './SelectVm.jsx'

export const FormItemVm = props => (
    <Form.Item
        label={meta.name}
        name="vm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemVms = props => {
    const form = Form.useFormInstance()
    const {ssCode} = Form.useWatch('ss', form) ?? {}

    return (
        <Form.Item
            label={meta.name}
            name="vms"
            {...props}
        >
            <Select multiple ssCode={ssCode} />
        </Form.Item>
    )
}
